import { observer } from "mobx-react-lite";
import { useState } from "react";
import { Col, Flex, Input, Button, Form } from "antd";
import { CustomButton } from "ui";
import { useStores } from "stores";
import { updateSettingsInfoText } from "services";
import { useNotificationContext } from "providers";
import { NOTIFICATION_TYPE_ENUM } from "interfaces";
import { _isRequired, parseErrorMessage, requestWithNotify } from "utils";
import { MarkdownBox } from "./MarkdownBox";
import { ReactComponent as InfoIcon } from "images/menuIcons/Info.svg";

import styles from "./markdown.module.css";
import { routes } from "constants/routes";

const { TextArea } = Input;

export const MarkdownModal = observer(() => {
  const { actionModals, settings } = useStores();
  const { openNotification } = useNotificationContext();

  const [markdownText, setMarkdownText] = useState(settings.infoText);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleCloseModal = () => {
    actionModals.closeAll();
  };

  const updateInfoTextHandler = async (values: { infoText: string }) => {
    setLoading(true);

    try {
      const res = await requestWithNotify({
        fetchFn: () => updateSettingsInfoText({ infoText: values.infoText }),
        openNotification,
        successMsg: "Текст изменен",
      });

      if (res.result) {
        setTimeout(() => {
          handleCloseModal();
          settings.fetchSettingsInfoText();
          setLoading(false);
        }, 1500);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Form form={form} name="info-text" onFinish={updateInfoTextHandler} initialValues={{ infoText: settings.infoText }}>
      <Flex vertical gap="large">
        <Flex gap="large" className={styles.markdownModalContent}>
          <Button
            type="link"
            size="small"
            icon={<InfoIcon />}
            onClick={() => {
              window.open(`${routes.markdownGuide}`, "_blank");
            }}
            className={styles.infoIcon}
          />
          <Col span={12}>
            <Form.Item
              className={styles.markdownTextareaBlock}
              rules={[_isRequired("Поле обязательно для заполнения")]}
              name="infoText"
            >
              <TextArea
                className={styles.markdownTextarea}
                placeholder="Введите markdown текст здесь..."
                onChange={(e) => {
                  setMarkdownText(e.target.value);
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12} className={styles.markdownPreview}>
            <MarkdownBox markdownText={markdownText} />
          </Col>
        </Flex>
        <Flex gap="large" className="margin-top-xs">
          <CustomButton htmlType="submit" disabled={loading} loading={loading}>
            Сохранить
          </CustomButton>
          <CustomButton htmlType="button" disabled={loading} type="default" onClick={handleCloseModal}>
            Закрыть
          </CustomButton>
        </Flex>
      </Flex>
    </Form>
  );
});
